import React, { useState, useEffect } from "react";
import { Routes, Route, Link, useParams } from "react-router-dom";

import "./App.css";

import KUREGYAN from "./books/kuregyan.js";
import TYULIN from "./books/tyulin.js";

const BOOKS = { kuregyan: KUREGYAN, tyulin: TYULIN };

const EXAMPLE_HEIGHT = "250px";
const DEBUG = window.location.hostname === "localhost";

const getPageNumber = (pageId) => parseInt(pageId.split(/\./)[0], 10);

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<Books />} />
        <Route path="/books/:bookId/:pageId" element={<Page />} />
        <Route path="/books/:bookId" element={<Book />} />
      </Routes>
    </div>
  );
}

const ListOfPages = ({ bookId, pages }) => {
  return (
    <div>
      {Object.keys(pages)
        .sort((a, b) => a.split(/\./)[0] - b.split(/\./)[0])
        .map((page) => (
          <li key={page}>
            <Link to={`/books/${bookId}/${page}`}>{page.split(/\./)[0]}</Link>
          </li>
        ))}
    </div>
  );
};

function Page() {
  const [evenCounter, setEvenCounter] = useState(0);
  const { bookId, pageId } = useParams();
  const [example, setExample] = useState();
  const pageNumber = getPageNumber(pageId);
  const [coords, setCoords] = useState({ x: 0, y: 0 });
  const [newReferences, setNewReferences] = useState([]);

  const [pageWidth, setPageWidth] = useState();
  const [pageHeight, setPageHeight] = useState();

  const recordPageDimensions = ({ target }) => {
    setPageWidth(target.naturalWidth);
    setPageHeight(target.naturalHeight);
  };

  const book = BOOKS[bookId];
  const { images } = book;
  useEffect(() => {
    document.title = book.title;
  });

  const imgPercentageHeight = (height) => `${(height / pageHeight) * 100}%`;
  const imgPercentageWidth = (width) => `${(width / pageWidth) * 100}%`;

  useEffect(() => {
    setTimeout(() => {
      window.dispatchEvent(new Event("resize"));
    }, 0);
  }, []);

  const handleClick = (event) => {
    if (!DEBUG) {
      return;
    }
    const prevCoords = coords;
    const x = event.pageX - event.target.getBoundingClientRect().left;
    const y = event.pageY - event.target.getBoundingClientRect().top;
    let name, youtubeLink;
    setEvenCounter(evenCounter + 1);
    if (evenCounter % 2 === 1) {
      name = prompt("Введите номер примера");
      youtubeLink =
        prompt("Введите ссылку на ютьюб", "LINK")
          .replace("youtu.be/", "youtube.com/embed/")
          .replace("t=", "start=") + "&autoplay=1";
      let newReference;
      if (pageNumber < 245) {
        newReference = {
          page: pageNumber,
          left: prevCoords.x,
          right: x,
          top: prevCoords.y,
          bottom: y,
          name,
          ...(book.layout === "INLINE" && { example: { youtubeLink } }),
        };
      } else {
        // Only for book.layout == "SEPARATE"
        newReference = {
          page: pageNumber,
          top: prevCoords.y,
          bottom: y,
          name,
          youtubeLink: "LINK",
        };
      }
      setNewReferences([...newReferences, newReference]);
    }
    setCoords({
      x,
      y,
    });
  };

  const referencesOnThisPage = book.joinedReferences.filter(
    ({ page }) => page == pageNumber
  );

  return (
    <>
      {example && (
        <div key="example">
          <div
            style={{
              overflowX: "scroll",
              position: "fixed",
              top: 20,
              left: 20,
            }}
          >
            <div
              style={{
                width: pageWidth,
                height: example.bottom - example.top,
                backgroundImage: "url('" + images[`${example.page}.png`] + "')",
                backgroundPosition: `-${0.9 * 60}px -${0.9 * example.top}px`,
                backgroundSize: `${0.9 * 100}%`,
                transform: `scale(${document.body.clientWidth / pageWidth})`,
                backgroundRepeat: "no-repeat",
                transformOrigin: "0 50%",
              }}
            />
          </div>
          {example.youtubeLink && example.youtubeLink !== "LINK" && (
            <div style={{ position: "fixed", bottom: 0, right: 0, zIndex: 10 }}>
              <iframe
                key={example.youtubeLink}
                id="ytplayer"
                type="text/html"
                width="200"
                height="200"
                src={example.youtubeLink}
                allow="autoplay"
                frameBorder="0"
              />
            </div>
          )}
        </div>
      )}
      <div
        key="nav"
        style={{
          position: "fixed",
          backgroundColor: "white",
          padding: "30px",
          bottom: 0,
          left: 0,
          zIndex: 1,
          border: "1px solid gray",
          borderRadius: "5px",
        }}
      >
        <div>
          <Link to={`/books/${bookId}`}>все страницы</Link>

          <div style={{ marginTop: "10px" }}>
            {`${pageNumber - 1}.png` in images && (
              <>
                ...{" "}
                <Link to={`/books/${bookId}/${pageNumber - 1}.png`}>
                  {pageNumber - 1}
                </Link>
              </>
            )}
            <span style={{ margin: "20px" }}>{pageNumber}</span>
            {`${pageNumber + 1}.png` in images && (
              <>
                <Link to={`/books/${bookId}/${pageNumber + 1}.png`}>
                  {pageNumber + 1}
                </Link>{" "}
                ...
              </>
            )}
            {DEBUG && (
              <>
                References: <div>{JSON.stringify(newReferences)}</div>
              </>
            )}
          </div>
        </div>
      </div>
      <div
        style={{
          position: "fixed",
          top: book.layout === "SEPARATE" ? EXAMPLE_HEIGHT : 0,
          bottom: "0px",
          overflowY: "scroll",
        }}
      >
        <div style={{ position: "relative", marginBottom: "400px" }}>
          <img
            onLoad={recordPageDimensions}
            src={images[pageId]}
            onClick={handleClick}
            style={{ maxWidth: "100%", height: "auto" }}
          />
          {pageWidth > 0 &&
            referencesOnThisPage.map(
              ({ left, right, top, bottom, example }) => (
                <div
                  key={`${left}-${top}`}
                  style={{
                    border: `1px dotted ${
                      !example || example?.youtubeLink === "LINK"
                        ? "red"
                        : "blue"
                    }`,
                    cursor: "pointer",
                    position: "absolute",
                    top: imgPercentageHeight(top),
                    left: imgPercentageWidth(left),
                    width: imgPercentageWidth(right - left),
                    height: imgPercentageHeight(bottom - top),
                  }}
                  onClick={() => {
                    setExample(example);
                  }}
                />
              )
            )}
        </div>
      </div>
    </>
  );
}

function Books() {
  useEffect(() => {
    document.title = "Кюрегян и Тюлин";
  });

  return (
    <>
      {Object.entries(BOOKS).map(([bookId, book]) => (
        <h2 key={bookId}>
          <Link to={`/books/${bookId}`}>{book.title}</Link>
        </h2>
      ))}
      <div style={{ marginTop: "200px" }}>t.me/vitalypavlenko</div>
    </>
  );
}

function Book() {
  const { bookId } = useParams();
  const book = BOOKS[bookId];
  useEffect(() => {
    document.title = book.title;
  });

  const filterImagesByRange = (from, to) => {
    return Object.fromEntries(
      Object.entries(book.images).filter(
        ([image]) => from <= getPageNumber(image) && getPageNumber(image) <= to
      )
    );
  };

  return (
    <>
      <Link to="/">все книги</Link>
      {book.chapters.map((chapter) => (
        <div key={chapter.title}>
          <h2>{chapter.title}</h2>
          <ListOfPages
            bookId={bookId}
            pages={filterImagesByRange(chapter.from, chapter.to)}
          />
        </div>
      ))}
    </>
  );
}

export default App;
